/* eslint-disable no-extend-native */

Array.prototype.max = function () {
	return Number.isFinite(Math.max.apply(null, this))
		? Math.max.apply(null, this)
		: 0
}

Array.prototype.min = function () {
	return Number.isFinite(Math.min.apply(null, this))
		? Math.min.apply(null, this)
		: 0
}
